import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Affix, message } from 'antd';
import './AddCustomer.css';
import { addCustomer, clearAddCustomerErrors } from '../../redux/actions/customers';
import { setCaption } from '../../../../common/redux/actions/interfaceActions';
import * as URLs from '../../../../common/constants/systemUrls';

import AddCustomerForm from '../../components/AddCustomer/AddCustomerForm';
import { FormProgress } from '../../components/FormProgress/FormProgress';

import progresses from '../../components/FormProgress/progresses';
import { dadataClearSelected } from '../../../Authorization/redux/actions/daData';
import {
  showConfirmCancelAdding,
  showConfirmSave
} from '../../components/common/modal/confirmModal/ConfirmModal';

const initalState = {
  formProgress: progresses.default,
  data: {}
};

class AddCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initalState
    };
    this.formRef = null;
  }

  componentDidMount() {
    this.props.setCaption({
      enabled: true,
      captionType: 'crumbs',
      mainCaption: 'Добавление заказчика',
      breadCrumbs: [
        { path: '/' + URLs.CONTROL_PANEL, breadcrumbName: 'Панель управления' },
        { path: '/' + URLs.CUSTOMERS, breadcrumbName: 'Заказчики' },
        { breadcrumbName: 'Добавление заказчика' }
      ]
    });
  }

  handleFieldsChange = values => {
    this.setState(
      { ...this.state, data: { ...this.state.data, ...values } },
      () => {
        this.updateProgress(values);
      }
    );
  };

  updateProgress = values => {
    const form = this.formRef.props.form;
    if (form) {
      let newFormProgress = null;
      Object.keys(values).forEach(name => {
        this.state.formProgress.forEach((step, index) => {
          if (step.fields.some(fieldName => fieldName === name) && step.check) {
            const fieldsValue = form.getFieldsValue(step.fields);
            const check = step.check(fieldsValue, form);
            if (!newFormProgress) {
              newFormProgress = [...this.state.formProgress];
              newFormProgress = [
                ...newFormProgress.slice(0, index),
                {
                  ...newFormProgress[index],
                  name: step.name,
                  completed: check,
                  fieldsValue: fieldsValue
                },
                ...newFormProgress.slice(index + 1)
              ];
            }
          }
        });
      });

      if (newFormProgress) {
        this.setState({ ...this.state, formProgress: newFormProgress });
      }
    }
  };

  onSubmitForm = e => {
    this.formRef.props.form.validateFields((err, values) => {
      if (!values.subjectKey) {
        message.error('Начните заполнять данные');
        throw new Error('Начните заполнять данные');
      } else if (err) {
        throw new Error(err);
      }
      return values;
    }).then((values) => {
      const companyId = this.props.companyId;
      this.props.addCustomer({companyId, customerData: values});
    }).catch((err) => {
      console.error(err);
    });
  };

  render() {
    const { dadataClearSelected, dadataSelected, errors, clearAddCustomerErrors } = this.props;
    const { data } = this.state;
    return (
      <div className="add-customer basicForm">
        <Row gutter={16}>
          <Col span={18} className="add-customer__form-wrapper">
            <AddCustomerForm
              wrappedComponentRef={inst => (this.formRef = inst)}
              handleFieldsChange={this.handleFieldsChange}
              dadataClearSelected={dadataClearSelected}
              dadata={dadataSelected}
              data={data}
              errors={errors}
              clearAddCustomerErrors={clearAddCustomerErrors}
            />
          </Col>
          <Col span={6} className="add-customer__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById('mainSheet')}
            >
              <div className="add-customer__button-wrap">
                <Button
                  type="primary"
                  htmlType="button"
                  size="large"
                  className="add-customer__submit"
                  style={{ width: '100%' }}
                  onClick={() => {
                    showConfirmSave({
                      onOk: () => {
                        this.onSubmitForm();
                      }
                    });
                  }}
                >
                  Добавить заказчика
                </Button>
              </div>
              <div className="add-customer__progress-bar">
                <FormProgress progress={this.state.formProgress} />
              </div>
              <div className="add-customer__button-wrap">
                <Button
                  type="primary"
                  htmlType="button"
                  size="large"
                  className="add-customer__cancel"
                  style={{
                    width: '100%',
                    borderColor: '#F5222D',
                    color: '#F5222D'
                  }}
                  ghost
                  onClick={() => {
                    showConfirmCancelAdding({
                      onOk: () => {
                        this.props.history.push('/customers/');
                      }
                    });
                  }}
                >
                  Отмена
                </Button>
              </div>
            </Affix>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(
  state => ({
    dadataSelected: state.Authorization.dadata.selected,
    errors: state.Customers.customers.errorMessage,
    companyId: state.Authorization.activeProfile.companyId
  }),
  {
    setCaption,
    addCustomer,
    dadataClearSelected,
    clearAddCustomerErrors
  }
)(AddCustomer);
